import * as types from '../types';

export const empty: types.Rect = {
  width: 0,
  height: 0
}
